import { render, staticRenderFns } from "./handleOrdersThree.vue?vue&type=template&id=f0135c6c&scoped=true&"
import script from "./handleOrdersThree.vue?vue&type=script&lang=js&"
export * from "./handleOrdersThree.vue?vue&type=script&lang=js&"
import style0 from "./handleOrdersThree.vue?vue&type=style&index=0&id=f0135c6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0135c6c",
  null
  
)

export default component.exports